@if (detailsLoading) {
    <app-loader />
} @else {
    <app-tooltip
        class="disc-tooltip"
        [isEnabled]="mode === 'detail' && disabledMode">
        <form trigger class="pr-2" [formGroup]="form">
            @if (
                mode === 'detail' &&
                discDetail.currentState &&
                workflowStates.length > 0
            ) {
                <app-stepper
                    [steps]="workflowStates"
                    [activeStep]="discDetail.currentState.id" />
                <mat-divider />
            }
            <div class="info-section bordered">
                <app-content-field
                    label="ANALYST"
                    [required]="true"
                    [error]="
                        discDetail.analyst === null &&
                        (discDetail.status === 'Initial Review' ||
                            discDetail.status === 'Await Correction') &&
                        mode === 'detail'
                    ">
                    {{ discDetail.analyst?.displayName | dashIfEmpty }}
                </app-content-field>
                <app-content-field label="STATUS">
                    <span wfeGrayBox>
                        {{ discDetail.status }}
                    </span>
                </app-content-field>
                <app-content-field label="COMPLETION">
                    {{ completion | dashIfEmpty }}
                </app-content-field>
                @if (shouldShowPriorityDisplay) {
                    <app-content-field label="PRIORITY">
                        <app-priority-field [priority]="discDetail.priority" />
                    </app-content-field>
                } @else {
                    <app-priority-select
                        label="PRIORITY"
                        variant="secondary"
                        formControlName="priority"
                        selectStyle="height: 22px"
                        [forceDisabled]="disabledMode"
                        [value]="discDetail.priority"
                        [options]="editOptions.priority" />
                }
                <app-content-field label="CREATE DATE">
                    {{ discDetail.createdAt }}
                </app-content-field>
            </div>
            <mat-divider />
            <div class="info-section">
                <div class="flex flex-column">
                    @if (isInReadOnlyDetailMode) {
                        <app-content-field
                            label="REASON"
                            [warning]="!discDetail.reasonOptionExist"
                            [rowGap]="discDetail.reasonOptionExist">
                            {{ discDetail.reason?.displayName }}
                        </app-content-field>
                        @if (!discDetail.reasonOptionExist) {
                            <span
                                class="error-text text-med text-xs color-orange5"
                                >{{ reasonWarningMessage }}</span
                            >
                        }
                    } @else {
                        <app-select
                            label="REASON"
                            formControlName="reason"
                            [required]="true"
                            [searchable]="true"
                            [forceDisabled]="disabledMode"
                            [options]="editOptions.reason"
                            [value]="discDetail.reason?.backingField"
                            [unknownLabel]="
                                isReasonValueInvalid()
                                    ? discDetail.reason?.displayName
                                    : undefined
                            "
                            [missingWarningMessage]="
                                isReasonValueInvalid()
                                    ? reasonWarningMessage
                                    : undefined
                            " />
                    }
                </div>
                @if (isInReadOnlyDetailMode) {
                    <app-content-field label="PAGE RANGE">
                        {{ discDetail.pageRange | dashIfEmpty }}
                    </app-content-field>
                } @else {
                    <div>
                        <app-input
                            label="PAGE RANGE *"
                            formControlName="pageRange"
                            [control]="pageRange"
                            [disabled]="disabledMode"
                            [labelWithoutError]="disabledMode">
                            <span class="send-only-selected-pages-help">
                                <app-checkbox
                                    size="small"
                                    label="Send only selected pages"
                                    formControlName="notifyWithOnlySelectedPages"
                                    [dataQa]="
                                        dataQa.notifyWithOnlySelectedPagesCheckbox
                                    "
                                    [disabled]="
                                        docSizeExceedMaxLimit() || disabledMode
                                    "
                                    [checked]="
                                        discDetail.notifyWithOnlySelectedPages
                                    " />
                                <app-tooltip
                                    class="send-only-selected-pages-tooltip"
                                    panelClass="send-only-selected-pages-tooltip-panel">
                                    <button
                                        trigger
                                        type="button"
                                        class="send-only-selected-pages-info-button"
                                        (click)="$event.stopPropagation()"
                                        [attr.aria-label]="
                                            sendOnlySelectedPagesTooltip
                                        ">
                                        <mat-icon
                                            svgIcon="info"
                                            aria-hidden="true" />
                                    </button>
                                    <span content>
                                        {{ sendOnlySelectedPagesTooltip }}
                                    </span>
                                </app-tooltip>
                            </span>
                            @switch (true) {
                                @case (pageRange.hasError('pageRangeFormat')) {
                                    <app-page-range-format-error
                                        error
                                        class="color-status-red5" />
                                }
                                @case (
                                    pageRange.hasError('pageRangeConflict')
                                ) {
                                    <app-page-range-conflict-error
                                        error
                                        [data]="pageRangeConflictData"
                                        class="color-status-red5" />
                                }
                                @case (pageRange.hasError('pageRangeExceed')) {
                                    <app-page-range-exceed-error
                                        class="color-status-red5"
                                        error
                                        [max]="
                                            discDetail.revision?.pageSize ??
                                            null
                                        " />
                                }
                            }
                        </app-input>
                        @if (docSizeExceedMaxLimit()) {
                            <app-page-range-limitation
                                [discDetail]="discDetail" />
                        }
                    </div>
                }
            </div>
            <div class="info-section">
                <div class="flex flex-column">
                    @if (isInReadOnlyDetailMode) {
                        <app-content-field
                            label="RESPONSIBLE STATION"
                            [errorForLabel]="shouldShowInactiveStationError">
                            {{ discDetail.station?.displayName }}
                        </app-content-field>
                        @if (
                            showStationError() && !discDetail.stationAssociated
                        ) {
                            <span
                                class="text-xxs text-light color-status-red5 mt-1 error-text"
                                style="width: 100%">
                                Invalid station. Please
                                <b>
                                    click Recall and select another station to
                                    enable Re-Notify.
                                </b>
                            </span>
                        } @else if (shouldShowInactiveStationError) {
                            <span
                                class="text-xxs text-light color-status-red5 mt-1 error-text"
                                style="width: 100%">
                                This station is marked as inactive. Please
                                <b>
                                    click Recall and select another station to
                                    enable Re-Notify.
                                </b>
                            </span>
                        }
                    } @else {
                        <app-select
                            label="RESPONSIBLE STATION"
                            formControlName="station"
                            [control]="stationId"
                            [required]="true"
                            [forceDisabled]="disabledMode"
                            [value]="discDetail.station?.backingField"
                            [options]="editOptions.station"
                            [unknownLabel]="
                                stationId.hasError('optionNotFound')
                                    ? discDetail.station?.displayName
                                    : undefined
                            " />
                        @if (stationId.hasError('optionNotFound')) {
                            @if (!discDetail.stationAssociated) {
                                <span
                                    class="text-xxs text-light color-status-red5 mt-1">
                                    This station is no longer valid. Please
                                    <b> select another station. </b>
                                </span>
                            } @else if (
                                discDetail.stationStatus === Status.Inactive
                            ) {
                                <span
                                    class="text-xxs text-light color-status-red5 mt-1">
                                    This station is marked as inactive. Please
                                    select another station.
                                </span>
                            }
                        }
                    }
                </div>
                <app-fixer-field
                    [id]="id"
                    [readOnly]="
                        mode === 'summary' ||
                        (readOnly && discDetail.status !== 'Initial Review')
                    "
                    [forceDisabled]="disabledMode"
                    [value]="{
                        primaryFixer: discDetail.primaryFixer,
                        secondaryFixers: discDetail.secondaryFixers,
                    }"
                    [stationId]="stationId.value"
                    [externalFixerIds]="automationFixerIds"
                    [automationRuleGroups]="automationRuleGroups"
                    (fixerOptionsLoaded)="onFixerOptionsLoaded($event)"
                    (fixerUpdated)="updateFixer($event)" />
            </div>
            <div
                class="info-section"
                [class.custom-columns-paired]="customColumns.length > 0">
                @if (isInReadOnlyDetailMode) {
                    <app-content-field label="DIRECTIONS">
                        {{ discDetail.directions | dashIfEmpty }}
                    </app-content-field>
                } @else {
                    <app-textarea
                        label="DIRECTIONS"
                        formControlName="directions"
                        [maxLength]="maxDirectionsLength"
                        [disabled]="disabledMode" />
                }
                @if (customColumns.length > 0) {
                    @if (isInReadOnlyDetailMode) {
                        <div class="custom-columns-inline">
                            @for (col of customColumns; track col.id) {
                                <app-content-field
                                    [label]="getCustomColumnLabel(col)">
                                    {{
                                        getCustomColumnDisplay(col)
                                            | dashIfEmpty
                                    }}
                                </app-content-field>
                            }
                        </div>
                    } @else {
                        <ng-container formGroupName="customColumns">
                            <div class="custom-columns-inline">
                                @for (col of customColumns; track col.id) {
                                    @if (isCustomColumnListBox(col)) {
                                        <app-select
                                            [label]="getCustomColumnLabel(col)"
                                            [formControlName]="col.columnName"
                                            [options]="
                                                getCustomColumnOptions(col)
                                            "
                                            [forceDisabled]="disabledMode" />
                                    } @else if (isCustomColumnDate(col)) {
                                        <app-datepicker
                                            [label]="getCustomColumnLabel(col)"
                                            [formControlName]="col.columnName"
                                            [style.width]="'100%'"
                                            [disabled]="disabledMode" />
                                    } @else {
                                        <app-input
                                            [label]="getCustomColumnLabel(col)"
                                            [type]="
                                                getCustomColumnInputType(col)
                                            "
                                            [maxLength]="
                                                isCustomColumnNumber(col)
                                                    ? null
                                                    : customColumnMaxLength
                                            "
                                            [integerOnly]="
                                                isCustomColumnNumber(col)
                                            "
                                            [trimOnBlur]="
                                                !isCustomColumnNumber(col)
                                            "
                                            [hideNumberSpinner]="
                                                isCustomColumnNumber(col)
                                            "
                                            [min]="
                                                isCustomColumnNumber(col)
                                                    ? customColumnIntMin
                                                    : null
                                            "
                                            [max]="
                                                isCustomColumnNumber(col)
                                                    ? customColumnIntMax
                                                    : null
                                            "
                                            [overlayMaxLengthCounter]="true"
                                            [formControlName]="col.columnName"
                                            [disabled]="disabledMode" />
                                    }
                                }
                            </div>
                        </ng-container>
                    }
                }
            </div>
            @if (shouldShowVersionSelect) {
                <div class="info-section">
                    <app-select
                        label="SELECT A VERSION TO SEND FOR CORRECTION:"
                        formControlName="revision"
                        [options]="editOptions.revision"
                        [forceDisabled]="disabledMode" />
                </div>
            }
        </form>
        @switch (tooltipTextType()) {
            @case ('take') {
                <ng-container
                    content
                    *ngTemplateOutlet="takeToEditTooltipContent" />
            }
            @case ('cannotTake') {
                <ng-container
                    content
                    *ngTemplateOutlet="cannotEditTooltipContent" />
            }
        }
    </app-tooltip>
    <app-discrepancy-collapsibles
        [discrepancyId]="discDetail.id"
        [showComments]="mode === 'detail' && areCommentsEnabled"
        [showEscalation]="mode === 'detail'" />
    @if (mode === 'detail') {
        <ng-container>
            <div class="actions ml-n4 pl-2 pr-4">
                @if (discDetail) {
                    <app-footer-assign-actions
                        [discDetail]="discDetail"
                        [editOptions]="editOptions"
                        [isAdmin]="isAdmin"
                        [canTakeByRoleAndCollaborator]="
                            canCurrentUserTakeDiscrepancy()
                        "
                        [isSecondaryCollaborator]="isSecondaryCollaborator"
                        [allowCollaboratorTakeAssignedDiscrepancy]="
                            allowCollaboratorTakeAssignedDiscrepancy
                        " />
                    <app-tooltip
                        class="disc-tooltip"
                        [isEnabled]="isFooterActionsTooltipEnabled()">
                        <div trigger>
                            <app-footer-state-actions
                                [discDetail]="discDetail"
                                [canSave]="canSave"
                                [canNotify]="canNotify"
                                [isAdmin]="isAdmin"
                                [isSecondaryCollaborator]="
                                    isSecondaryCollaborator
                                "
                                [isRecordsManager]="isRecordsManager"
                                [isRmInactive]="isRmInactive"
                                [canTakeDiscrepancy]="
                                    canCurrentUserTakeDiscrepancy()
                                "
                                [parentTooltipEnabled]="
                                    isFooterActionsTooltipEnabled()
                                "
                                [reNotifyDisabled]="isStationValueInvalid()"
                                [editForm]="form"
                                [editFormChanged]="editFormChanged"
                                [editOptions]="editOptions"
                                [normalizeCustomColumnValues]="
                                    normalizeCustomColumnValues.bind(this)
                                "
                                (saveFailed)="onSaveFailed($event)" />
                        </div>
                        @switch (tooltipTextType()) {
                            @case ('take') {
                                <ng-container
                                    content
                                    *ngTemplateOutlet="
                                        takeToActionsTooltipContent
                                    " />
                            }
                            @case ('cannotTake') {
                                <ng-container
                                    content
                                    *ngTemplateOutlet="
                                        cannotPerformTooltipContent
                                    " />
                            }
                        }
                    </app-tooltip>
                }
            </div>
        </ng-container>
    }
}
<ng-template #takeToEditTooltipContent
    ><span
        >Please
        <b>
            take {{ isAdmin && !isRecordsManager ? 'or assign' : '' }} the
            discrepancy
        </b>
        to enable fields.</span
    ></ng-template
>
<ng-template #takeToActionsTooltipContent
    ><span
        >Please
        <b>
            take {{ isAdmin && !isRecordsManager ? 'or assign' : '' }} the
            discrepancy
        </b>
        to enable actions.</span
    ></ng-template
>
<ng-template #cannotEditTooltipContent
    ><span>You cannot edit this discrepancy.</span></ng-template
>
<ng-template #cannotPerformTooltipContent
    ><span>You cannot perform actions on this discrepancy.</span></ng-template
>
